/* eslint-disable */
import { createRouter, createWebHistory } from "vue-router";

const LoginOne = () => import("@/components/Login.vue");
const TasksOne = () => import("@/components/Tasks.vue");
const ProjectsList = () => import("@/components/ProjectsList.vue");
const CreateProject = () => import("@/components/CreateProject.vue");
const ContactsList = () => import("@/components/ContactsList.vue");
const ClientsList = () => import("@/components/ClientsList.vue");
const ProjectDetails = () => import("@/components/ProjectDetails.vue");
const ManagementDashboard = () => import("@/components/ManagementDashboard.vue");
const EditOrder = () => import("@/components/EditOrder.vue");
const EditOrderBolts = () => import("@/components/EditOrderBolts.vue");

const routes = [
  {
    path: "/",
    name: "login",
    component: LoginOne,
  },
  {
    path: "/login",
    name: "LoginOne",
    component: LoginOne,
  },
  {
    path: "/tasks",
    name: "TasksOne",
    component: TasksOne,
  },
  {
    path: "/projects",
    name: "ProjectsList",
    component: ProjectsList,
  },
  {
    path: "/management-dashboard",
    name: "ManagementDashboard",
    component: ManagementDashboard,
  },
  {
    path: "/create-project",
    name: "CreateProject",
    component: CreateProject,
  },
  {
    path: "/contacts",
    name: "ContactsList",
    component: ContactsList,
  },
  {
    path: "/clients",
    name: "ClientsList",
    component: ClientsList,
  },
  {
    path: "/projects/:id",
    name: "ProjectDetails",
    component: ProjectDetails,
    props: true,
  },
  // {
  //   path: "/upload-files/:id",
  //   name: "UploadFiles",
  //   component: UploadFiles,
  //   props: true,
  // },
  {
    path: "/edit-order/:id",
    name: "EditOrder",
    component: EditOrder,
    props: true,
  },
  {
    path: "/orders/:orderId/edit-bolts",
    name: "edit-order-bolts",
    component: EditOrderBolts,
    props: true,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// ✅ Global auth guard: ONLY login routes are public
router.beforeEach((to) => {
  const token = localStorage.getItem("authToken");

  const isLoginRoute =
    to.path === "/" ||
    to.path === "/login" ||
    to.name === "login" ||
    to.name === "LoginOne";

  // Public routes: login pages only
  if (isLoginRoute) {
    // Optional: if already logged in, send away from login
    // if (token) return { path: "/tasks" };
    return true;
  }

  // Protected routes: everything else
  if (!token) {
    return { path: "/login", query: { redirect: to.fullPath } };
  }

  return true;
});

export default router;
